import classNames from "classnames";
import { Sparkles } from "lucide-react";

export function AddOnBadge({ className }: { className?: string }) {
  return (
    <span
      className={classNames(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs w-fit text-[#FF4C00]",
        "border-[#FF4C00] bg-[#FFF0F1] text-destructive",
        className)}
    >
      <Sparkles className="text-[#FF4C00]" width={20} />
      Add Ons
    </span>
  )
}
